import {
  DateOnlySchema,
  DatePeriodSchema,
  TimeOfDayPeriodSchema,
} from "@greeter/date";
import z from "zod";
import { ImageAssetSchema } from "./ImageAsset";
import { TicketProductSchema } from "./TicketProduct";
import { BundleIdSchema } from "./Bundle";

export const TicketEventPublishingStatusSchema = z
  .union([z.literal("published"), z.literal("draft")])
  .default("draft");

export type TicketEventPublishingStatus = z.infer<
  typeof TicketEventPublishingStatusSchema
>;

export const TicketEventDateTimePeriodSchema = z.object({
  date: DateOnlySchema,
  timePeriod: TimeOfDayPeriodSchema,
});

export const TicketEventPeriodSchema = z.discriminatedUnion("type", [
  // TODO: Implement
  z.object({
    type: z.literal("recurring"),
  }),
  z.object({
    type: z.literal("once"),
    ...TicketEventDateTimePeriodSchema.shape,
  }),
  // TODO: Implement
  z.object({
    type: z.literal("multiple"),
    periods: z.array(TicketEventDateTimePeriodSchema),
  }),
]);

export const TicketEventIdSchema = z.string().brand("TicketEventId");
export type TicketEventId = z.infer<typeof TicketEventIdSchema>;

export const TicketEventSchema = z.object({
  id: TicketEventIdSchema,

  title: z.string(),
  slug: z.string(),
  description: z.string(),
  address: z.string(),

  eventPeriod: TicketEventPeriodSchema,

  salesPeriod: DatePeriodSchema.optional().nullable(),

  tickets: TicketProductSchema,

  coverAssets: z.array(ImageAssetSchema),
  publishingStatus: TicketEventPublishingStatusSchema,

  bundles: z.array(BundleIdSchema).default([]),
});

export type TicketEvent = z.infer<typeof TicketEventSchema>;

export const VenueTicketEventSchema = TicketEventSchema.extend({
  ticketCount: z.number().default(0),
  ticketCheckedInCount: z.number().default(0),
});

export type VenueTicketEvent = z.infer<typeof VenueTicketEventSchema>;
